"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProviderInternal = void 0;
const solana_contrib_1 = require("@saberhq/solana-contrib");
const react_1 = require("react");
const useProviderInternal = ({ connection, sendConnection = connection, wallet, commitment = "recent", commitmentMut = "recent", }) => {
    const provider = (0, react_1.useMemo)(() => new solana_contrib_1.SolanaReadonlyProvider(connection, {
        commitment,
    }), [commitment, connection]);
    const connected = wallet === null || wallet === void 0 ? void 0 : wallet.connected;
    const publicKey = wallet === null || wallet === void 0 ? void 0 : wallet.publicKey;
    const providerMut = (0, react_1.useMemo)(() => wallet && connected && publicKey
        ? solana_contrib_1.SolanaProvider.load({
            connection,
            sendConnection,
            wallet: wallet,
            opts: {
                commitment: commitmentMut,
            },
        })
        : null, [wallet, connected, publicKey, connection, sendConnection, commitmentMut]);
    return {
        provider,
        providerMut,
    };
};
exports.useProviderInternal = useProviderInternal;
//# sourceMappingURL=useProviderInternal.js.map